import {
  CURB_LANE_WIDTH,
  CURB_LANE_WIDTH_VALUES,
  SPECIAL_CONSIDERATIONS,
  CURB_LANE_WIDTH_ADJUSTMENTS
} from '../constants/freight.js'

export const freightConfig = [
  {
    name: 'Curb Lane Width',
    id: CURB_LANE_WIDTH,
    inputType: 'dropDown',
    required: true,
    scores: [],
    inputValues: CURB_LANE_WIDTH_VALUES,
    notes:
      'Width of the curbside lane determines how well the roadway accommodates freight.'
  },
  {
    name: 'Curb Lane Width Adjustments',
    id: CURB_LANE_WIDTH_ADJUSTMENTS,
    inputType: 'checkBox',
    required: true,
    scores: null,
    inputValues: ['Mountable curb', 'Painted buffer'],
    notes: 'Leave unchecked if not applicable'
  },
  {
    name: 'Special Considerations',
    id: SPECIAL_CONSIDERATIONS,
    inputType: 'checkBox',
    required: true,
    scores: [],
    inputValues: [
      'Frequent freight loading from street',
      'Frequent package delivery from street'
    ],
    notes: 'Leave unchecked if not applicable'
  },
  {
    name: 'Freight Tier',
    id: 'tier',
    inputType: 'string',
    required: true,
    scores: null,
    notes: 'Value populated in project setup on previous page.',
    autoPopulated: true
  },
  {
    name: 'Land Use Context',
    id: 'land_use_context',
    inputType: 'string',
    required: true,
    scores: null,
    notes: 'Value populated in project setup on previous page.',
    autoPopulated: true
  }
]
